import {Outlet, createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/adgpt-trace-usage/$threadId",
)({
    component: Outlet,
});
